module.exports = __webpack_public_path__ + "static/media/level-seven.2fc9d3f8.svg";